import { toast } from '@kalos/ui';
import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';

import { useFeatureFlag } from '../featureFlags/useFeatureFlag';
import { ProjectSchedule } from '../modules/ProjectSchedule';
import { projectScheduleOpenCheck } from '../tools/permissionChecks';

/** The module behind its release flag: off sends the person home, as before the page existed. */
const ProjectScheduleRoute = () => {
  const released = useFeatureFlag('project-schedule.module', { scope: 'page' });
  return released ? <ProjectSchedule /> : <Navigate to="/" replace />;
};

export const Route = createFileRoute('/project-schedule')({
  component: ProjectScheduleRoute,
  loader(ctx) {
    // Coordinators and publishers work the board; the lodging desk reads the Overview.
    const user = ctx.context.authContext.user;
    if (!projectScheduleOpenCheck(user)) {
      toast({
        title: 'Access Denied',
        description:
          'You do not have permission to access Project Scheduling. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head() {
    return {
      meta: [{ title: 'Project Scheduling' }],
    };
  },
});
